import axios from "axios";
import { APPCONFIG } from "../Config";
import APIEndpoint from "./endpoint";

export const authentication = async (request) => {
  const url = `${APPCONFIG.GATEWAY_ENDPOINT + APIEndpoint.SIGN_IN_API}`;

  const payload = {
    requestObject: {
      username: request.username,
      password: request.password,
    },
  };

  const res = await axios.post(url, JSON.stringify(payload), {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const forgotPassword = async (request) => {
  const url = `${APPCONFIG.GATEWAY_ENDPOINT + APIEndpoint.FORGOT_PASSWORD_API}`;

  const payload = {
    requestObject: {
      email: request.email,
    },
  };

  const res = await axios.post(url, JSON.stringify(payload), {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};

export const signOut = async () => {
  const url = `${APPCONFIG.GATEWAY_ENDPOINT + APIEndpoint.SIGN_OUT_API}`;
  const res = await axios.post(url, {
    headers: { "Content-Type": "application/json" },
  });
  return res;
};
